import React, {useRef} from 'react'
import './step2.css'
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button'; 
import { Link } from "react-router-dom";
import TaxRegister from '../../Articles/TaxRegister';
import Licenses from '../../Articles/Licenses';
import UBO from '../../Articles/UBO';
const Step2 = () => {
  const stepperRef = useRef(null);
    const step1Ref = useRef(null);  // Add this ref for the container
  
    const scrollToTop = () => {
      step1Ref.current?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
  
    const handleNext = () => {
      stepperRef.current.nextCallback();
      scrollToTop();
    };
  
    const handlePrev = () => {
      stepperRef.current.prevCallback();
      scrollToTop();
    };
  
  return (
    <div className='step1' ref={step1Ref}>
            <div className='stepchat'>
                <Link to={'/chatbot'} ><Button style={{fontWeight:"500"}} className='buttonChat' squared>
                   <span>Talk to our chat</span> <img className='chatbotIcon' src={`${process.env.PUBLIC_URL}/Images/chatboticon.png`} alt="Chatbot Icon" /></Button></Link>
            </div>
          <h1 className='stepnumber'>STEP 2</h1>
          <h1 className='stepname'>Tax Registration and Licenses</h1>
          <div className="card w-full flex justify-content-center">
            <Stepper ref={stepperRef} >
                <StepperPanel header="Tax Register">
                    <div className="surface-ground flex flex-column h-full">
                        <div className="flex-auto flex flex-column align-items-start font-medium">
                       <TaxRegister />
                        </div>
                    </div>
                    <div className="button-container flex pt-4 justify-content-end">
                        <Button 
                          label="Next" 
                          icon="pi pi-arrow-right" 
                          iconPos="right" 
                          onClick={handleNext} 
                        />
                    </div>
                </StepperPanel>
                <StepperPanel header="License Registration">
                    <div className="surface-ground flex flex-column h-full">
                        <div className="flex-auto flex flex-column align-items-start font-medium">
                          <Licenses />
                        </div>
                    </div>
                    <div className="button-container flex pt-4 justify-content-between">
                        <Button 
                          label="Back" 
                          severity="secondary" 
                          icon="pi pi-arrow-left" 
                          onClick={handlePrev} 
                        />
                        <Button 
                          label="Next" 
                          icon="pi pi-arrow-right" 
                          iconPos="right" 
                          onClick={handleNext} 
                        />
                    </div>
                </StepperPanel>
                <StepperPanel header="Ultimate Beneficial Owner">
                    <div className="surface-ground flex flex-column h-full">
                        <div className="surface-ground flex-auto flex flex-column align-items-start font-medium">
                           <UBO />
                        </div>
                    </div>
                    <div className="button-container flex pt-4 justify-content-start">
                        <Button 
                          label="Back" 
                          severity="secondary" 
                          icon="pi pi-arrow-left" 
                          onClick={handlePrev} 
                        />
                    </div>
                </StepperPanel>
            </Stepper>
        </div>
    
        </div>

  )
}

export default Step2